import Marquee from "react-fast-marquee";
import { ShieldCheck } from "lucide-react";
import { TRUST_RIBBON } from "../data/site";

export default function TrustRibbon() {
  return (
    <div
      data-testid="trust-ribbon"
      className="border-y border-[#DCE7F5] bg-[#EAF3FF]/60 py-4"
    >
      <Marquee speed={28} gradient={false} pauseOnHover>
        {TRUST_RIBBON.concat(TRUST_RIBBON).map((item, idx) => (
          <span
            key={idx}
            className="mx-6 inline-flex items-center gap-2 text-sm font-medium text-[#0B2F6B]"
          >
            <ShieldCheck className="w-4 h-4 text-[#1E7BE0]" />
            {item}
          </span>
        ))}
      </Marquee>
    </div>
  );
}
